import {QueryClient} from "@tanstack/react-query";
import React from "react";

// https://tanstack.com/query/latest/docs/react/reference/QueryClient
// https://medium.com/doctolib/react-query-cachetime-vs-staletime-ec74defc483e
// https://tanstack.com/query/v4/docs/react/guides/important-defaults
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            //cacheTime: 1000*10*1,
            //refetchInterval: 1000*5*1,
            //refetchIntervalInBackground: true,
            //staleTime: Infinity, // il default è 0, di fatto vanifica l'effetto della cache.
            staleTime: 1000 * 10 * 1, // The time in milliseconds after data is considered stale.
        },
    },
})

//https://tanstack.com/query/v4/docs/react/devtools
const ReactQueryDevtoolsProduction = React.lazy(() =>
    // import('@tanstack/react-query-devtools/build/lib/index.prod.js').then(
    import('@tanstack/react-query-devtools/build/modern/production.js').then(
        (d) => ({
            default: d.ReactQueryDevtools,
        }),
    ),
)